import { createContext, useContext } from 'react';

export interface CommandPaletteContextValue {
  open: boolean;
  setOpen: (next: boolean) => void;
}

export const CommandPaletteContext = createContext<CommandPaletteContextValue | null>(null);

export function useCommandPalette(): CommandPaletteContextValue {
  const ctx = useContext(CommandPaletteContext);
  if (!ctx) {
    throw new Error('useCommandPalette must be used inside a CommandPaletteProvider');
  }
  return ctx;
}
